<template>
  <v-navigation-drawer clipped>
    <v-list dense nav class="py-0">
      <!-- categories -->
      <div class="categories-wrapper">
        <div class="icons-wrapper">
          <v-icon small color="rgba(0, 0, 0, 0.7)" v-show="isCategoryListOpen && !addCategoryMode" @click.stop="addCategory" class="edit-icon">mdi-plus</v-icon>

          <v-icon small color="rgba(0, 0, 0, 0.7)" v-show="addCategoryMode" @click.prevent="resetState" class="edit-icon">mdi-window-close</v-icon>
          <v-icon small color="rgba(0, 0, 0, 0.7)" v-show="addCategoryMode" @click.prevent="save" class="edit-icon">mdi-check-bold</v-icon>
        </div>

        <v-list-group no-action sub-group title="Categories" class="categories-title" :value="isCategoryListOpen" @click.native="isCategoryListOpen = !isCategoryListOpen">
          <template v-slot:activator>
            <v-list-item-title>Collections</v-list-item-title>
          </template>

          <v-list-item v-show="addCategoryMode" @click.stop @click.enter="save">
            <v-text-field ref="addCategoryInput" type="input" v-model="newCategory" color="rgb(20,200,200)" @click.stop></v-text-field>
          </v-list-item>
          <v-list-item v-show="!categories.length && isCategoryListOpen && !addCategoryMode" @click.stop="addCategory" link class="item-wrppaer">
            <v-icon small color="rgba(0, 0, 0, 0.7)" class="edit-icon">mdi-plus</v-icon>
            <span class="category">Add Collection </span>
          </v-list-item>

          <v-list-item @click.stop v-for="(category, index) in categories" :key="index" link class="item-wrppaer" @mouseover="mouseOverIndex = index" @mouseleave="mouseOverIndex = -1">
            <v-checkbox v-model="selectedCategories" :value="category" multiple>
              <template slot="label">
                <span class="category">{{ category }} {{ getProductsByCategory(category) }} </span>
              </template>
            </v-checkbox>
            <v-icon small color="rgba(0, 0, 0, 0.7)" v-show="isCategoryListOpen && !addCategoryMode && mouseOverIndex === index" @click.stop="removeCategoryFromList(category)" class="remove-icon">mdi-delete</v-icon>
            <v-icon small color="rgba(0, 0, 0, 0.7)" v-show="isCategoryListOpen && !addCategoryMode && mouseOverIndex === index" @click.stop="shareCategory(category)" class="remove-icon">mdi-share</v-icon>
          </v-list-item>
        </v-list-group>
      </div>

      <!-- stores -->
      <v-list-group no-action sub-group>
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>Stores</v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item v-show="!merchantUrls.length" link class="item-wrppaer">
          <span class="category">No Products </span>
        </v-list-item>

        <v-list-item v-for="(merchant, index) in merchantUrls" :key="index" link>
          <v-checkbox v-model="selectedMerchants" :value="merchant" multiple>
            <template slot="label">
              <span class="category">{{ merchant }} {{ getProductsByMerchant(merchant) }}</span>
            </template>
          </v-checkbox>
        </v-list-item>
      </v-list-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "sidebar",
  data() {
    return {
      mouseOverIndex: -1,
      addCategoryMode: false,
      newCategory: "",
      isCategoryListOpen: true,
      selectedCategories: [],
      selectedMerchants: [],
      items: [
        { title: "Price", icon: "mdi-image" },
        { title: "Shared", icon: "mdi-help-box" },
      ],
      processedCategories: [],
    };
  },
  computed: {
    ...mapGetters(["merchantUrls", "categories", "products"]),
  },
  methods: {
    ...mapActions(["addNewCategory"]),

    getProductsByCategory(category) {
      const counter = this.products.filter(
        (product) =>
          product.category &&
          product.category.findIndex(
            (productCategory) => productCategory === category
          ) > -1
      ).length;
      return `(${counter})`;
    },

    getProductsByMerchant(merchant) {
      const counter = this.products.filter(
        (product) => product.merchantUrl === merchant
      ).length;
      return `(${counter})`;
    },
    shareCategory(category) {
      this.mouseOverIndex = -1;
      const productIds = this.products
        .filter(
          (product) =>
            product.category &&
            product.category.findIndex(
              (productCategory) => productCategory === category
            ) > -1
        )
        .map((product) => product.productId)
        .join();
      this.$emit("shareCategory", productIds);
    },
    removeCategoryFromList(category) {
      this.mouseOverIndex = -1;
      const index = this.selectedCategories.indexOf(category);
      if (index > -1) {
        this.selectedCategories.splice(index, 1);
      }
      this.$emit("removeCategoryFromList", category);
    },
    addCategory() {
      this.addCategoryMode = true;
      this.$nextTick(() => this.$refs.addCategoryInput.focus());
      console.log(this.isCategoryListOpen);
    },
    save() {
      if (this.newCategory.length) {
        this.addNewCategory(this.newCategory);
      }
      this.resetState();
    },
    resetState() {
      this.addCategoryMode = false;
      this.newCategory = "";
    },
  },
  watch: {
    selectedCategories(newVal) {
      console.log(JSON.stringify(newVal));
      this.$emit("changeCategory", newVal ? newVal : []);
    },
    selectedMerchants(newVal) {
      console.log(JSON.stringify(newVal));
      this.$emit("changeMerchant", newVal ? newVal : []);
    },
  },
};
</script>

<style scoped>
.categories-wrapper {
  display: flex;
  flex-direction: row-reverse;
  align-content: center;
}

.icons-wrapper {
  display: flex;
  height: 40px;
  justify-content: center;
}

.item-wrppaer {
  display: flex;
}
.categories-title {
  flex: 1;
}

.category {
  flex: 1;
  font-size: 12px;
  font-weight: 700;
  opacity: 0.9;
}

.edit-icon {
  margin-left: 5px;
  /* flex: 1; */
  /* margin-left: 10px; */
  cursor: pointer;
}

.remove-icon {
  flex: 1;
  cursor: pointer;
}
</style>
